export class AovComparisonProductResult {
    public insuranceCompanyCode: string = '';

    public insuranceCompanyName: string = '';;

    public productName: string = '';

    public productInformationUrl: string = '';

    public premium: number = 0;
}